import React, { useState, useContext } from "react";
import { HouseContext } from "../../context/HouseContext";
import House from "../House/House";
import { Link } from "react-router-dom";
import { ImSpinner2 } from "react-icons/im";

const HouseList = () => {
  const { houses, loading } = useContext(HouseContext);
  const [visibleHouses, setVisibleHouses] = useState(6); // Mostrar 6 casas inicialmente

  const showMoreHouses = () => {
    setVisibleHouses((prevVisibleHouses) => prevVisibleHouses + 6);
  };

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center h-[100vh]">
        <ImSpinner2 className="animate-spin text-primary text-5xl mb-4" />
        <h2 className="text-white text-2xl ml-4">Cargando Propiedades...</h2>
      </div>
    );
  }

  if (!loading && houses.length === 0) {
    return (
      <div className="flex justify-center items-center text-center text-3xl text-white h-[100vh]">
        Lo sentimos, no hemos encontrado resultados
      </div>
    );
  }

  // Filtrar las casas para que no aparezcan las vendidas ni alquiladas
  const availableHouses = houses.filter(
    (house) => house.state !== "Vendido" && house.state !== "Alquilado"
  );

  // Verificar si no hay casas disponibles después de filtrar
  if (!loading && availableHouses.length === 0) {
    return (
      <div className="text-center text-3xl text-gray-400 my-[200px]">
        Lo sentimos, no hemos encontrado resultados
      </div>
    );
  }

  return (
    <section id="properties" className="mb-20 py-6 px-2">
      <div className="mx-auto max-w-[1500px]">
        <div className="flex justify-center items-center w-full flex-col mb-8">
          <h2 className="text-white text-4xl font-bold">
            NUESTRAS PROPIEDADES
          </h2>
          <h3 className="text-white text-lg mt-4">
            {" "}
            Conocé las propiedades más destacadas del mercado. La mejor y más
            exclusiva selección de propiedades en venta y alquiler.
          </h3>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-14 justify-center">
          {availableHouses.slice(0, visibleHouses).map((house, index) => (
            <Link to={`/propiedad/${house.id}`} key={index}>
              <House house={house} />
            </Link>
          ))}
        </div>
        {visibleHouses < availableHouses.length && (
          <div className="text-center mt-8">
            <button
              onClick={showMoreHouses}
              className="bg-white text-black px-4 py-2 rounded hover:opacity-80"
            >
              Ver más Propiedades
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default HouseList;
